export const KeywordsCell = ({ keywords }: { keywords: string }) => {
  return <>{keywords.split(', ').slice(-10).join(', ')}</>
}
